class LoyaltyTierDrawer extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.header.elements.forEach(element => {
      this.listeners.add(element, 'click', e =>
        this.handleTriggerClick(e.target),
      )
    })

    this.listeners.add(
      document.documentElement,
      'click',
      this.handleTriggerClickDocument.bind(this),
    )
  }

  handleTriggerClickDocument (e) {
    if (
      e.target.closest('[data-loyalty-tier-drawer-external-el="trigger"]') !==
      null
    ) {
      const target = e.target.closest(
        '[data-loyalty-tier-drawer-external-el="trigger"]',
      )
      this.handleTriggerClick(target)
    }
  }

  handleTriggerClick (e) {
    this.tier = e.dataset.tier
  }

  get tier () {
    return this._tier
  }

  set tier (tier) {
    this._tier = tier

    this.els.header.elements.forEach(element => {
      element.ariaSelected = element.dataset.tier === tier

      if (element.dataset.tier === tier) {
        this.style.backgroundColor = element.dataset.colour
      }
    })

    this.els.body.elements.forEach(element => {
      element.ariaHidden = element.dataset.tier !== tier
    })
  }
}

if (!customElements.get('loyalty-tier-drawer')) {
  customElements.define('loyalty-tier-drawer', LoyaltyTierDrawer)
}
